import React, {  useState } from "react";
interface UserData {
  carNumber?: string;
  phoneNumber?: string;
  email?: string;
}
const CustomerContext = React.createContext<{
  userData: UserData | null;
  setUserData: (v: UserData) => void;
  code?: string | null;
  setCode: (v: string) => void;
  restart: () => void;
  setTimer: () => void;
  checkTimer: () => boolean;
  setCurrentPosition: (v: string) => void;
  currentPosition?: string | null;
}>({
  userData: null,
  setUserData: () => null,
  code: null,
  setCode: () => null,
  restart: () => null,
  setTimer: () => null,
  checkTimer: () => false,
  currentPosition: null,
  setCurrentPosition: () => null,
});

export const CustomerContextProvider: React.FC = (props) => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [code, setCode] = useState<string | null>(null);
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [currentPosition, setCurrentPosition] = useState<string>("");
  const restart = () => {
    setUserData({
      carNumber: "",
      phoneNumber: "",
      email: "",
    });
  };
  const setTimer = async () => {
    setStartDate(new Date());
  };

  const checkTimer = () => {
    let currentDate = new Date();
    const dif = (currentDate.getTime() - startDate.getTime()) / 60000;
    return dif <= 10;
  };
  return (
    <CustomerContext.Provider
      value={{
        userData,
        setUserData,
        code,
        setCode,
        restart,
        setTimer,
        checkTimer,
        currentPosition,
        setCurrentPosition,
      }}
    >
      {props.children}
    </CustomerContext.Provider>
  );
};

export const useCustomerContext = () => React.useContext(CustomerContext);
